// Muss zum CACHE_PREFIX im Inline-Bootstrap-Script der index.html passen.
const CACHE_PREFIX = 'cc-style:';

// Wird nach einer CI-Änderung aufgerufen, bevor die Seite neu lädt.
//
// Das Inline-Script der index.html wendet den zwischengespeicherten Style
// synchron vor dem ersten Paint an. Bliebe der alte Eintrag stehen, sähe
// ausgerechnet der Mensch, der gerade gespeichert hat, nach dem Reload erst
// seine alte Farbwelt und dann den Umschlag. Ohne Eintrag wartet der Boot auf
// die frisch gerenderte Datei — kurz der Preloader, dann direkt das Ergebnis.
//
// Die übrigen Nutzer des Mandanten behalten ihren Cache und tauschen ihn
// einmalig beim nächsten Seitenaufruf; das ist der Preis dafür, dass sie
// sonst nie auf den Style warten.
export function discardCustomerStyleCache(): void {
  const subdomain = window.__ccStyle?.subdomain;
  if (!subdomain) {
    // Kein Bootstrap-Script gelaufen — dann gibt es auch nichts zu verwerfen.
    return;
  }
  try {
    window.localStorage.removeItem(`${CACHE_PREFIX}${subdomain}`);
  } catch {
    // Private Mode oder blockierter Speicher: es gab ohnehin keinen Eintrag.
  }
}

// What the boot actually waits for. Two cases, cheapest first:
//
//   1. The inline script in index.html already applied a style from its
//      localStorage cache — nothing to wait for, the CI is on screen before
//      the first paint. This is every repeat visit.
//   2. It is still fetching the pre-rendered file — wait for that one request.
//
// T009D6G6IUPE — there used to be a third case. Browsers still running an
// index.html from before T008W5FRD9WF carry no bootstrap script, and for those
// the style was fetched from a dynamic endpoint instead. That grace period is
// over: index.html is served without Cache-Control, so browsers revalidate it
// within hours via ETag rather than holding it for months. Without a bootstrap
// script the app now simply starts unstyled and the next load has the CI.
export async function waitForCustomerStyle(): Promise<void> {
  const bootstrap = window.__ccStyle;

  if (bootstrap?.applied) {
    return;
  }
  if (bootstrap?.ready) {
    await bootstrap.ready;
  }
}
